import Vue from 'vue'
import { convertCurrencyToFloat } from '~/utils/currency'

export const state = () => ({
  currentPremium: 0,
  quotes: []
})

export const mutations = {
  SET_QUOTES(state, payload) {
    let aux
    payload.forEach((element) => {
      if (element.has_premiums) {
        if (element.premiums.annual_premium !== null) {
          aux = element.premiums.annual_premium
          aux = Object.values(aux)[0]
          element.premiums.annual_premium = aux
        }
        if (element.premiums.monthly_premium !== null) {
          aux = element.premiums.monthly_premium
          aux = Object.values(aux)[0]
          element.premiums.monthly_premium = aux
        }
        if (element.premiums.semester_premium !== null) {
          aux = element.premiums.semester_premium

          aux = Object.values(aux)[0]
          element.premiums.semester_premium = aux
        }
        if (element.premiums.trimestral_premium !== null) {
          aux = element.premiums.trimestral_premium
          if (Object.values(aux)[0] === false) {
            element.premiums.trimestral_premium = null
          } else {
            aux = Object.values(aux)[0]
            /* aux = parseFloat(aux.slice(1).replace(',', '.')) */
            element.premiums.trimestral_premium = aux
          }
        }
      }
    })
    state.quotes = payload
  },
  SET_CURRENT_PREMIUM(state, payload) {
    state.currentPremium = payload
  },
  UPDATE_QUOTE(state, payload) {
    let aux
    if (payload.has_premiums) {
      if (payload.premiums.annual_premium !== null) {
        aux = payload.premiums.annual_premium
        aux = Object.values(aux)[0]
        payload.premiums.annual_premium = aux
      }
      if (payload.premiums.monthly_premium !== null) {
        aux = payload.premiums.monthly_premium
        aux = Object.values(aux)[0]
        payload.premiums.monthly_premium = aux
      }
      if (payload.premiums.semester_premium !== null) {
        aux = payload.premiums.semester_premium

        aux = Object.values(aux)[0]
        payload.premiums.semester_premium = aux
      }
      if (payload.premiums.trimestral_premium !== null) {
        aux = payload.premiums.trimestral_premium
        if (Object.values(aux)[0] === false) {
          payload.premiums.trimestral_premium = null
        } else {
          aux = Object.values(aux)[0]
          /* aux = parseFloat(aux.slice(1).replace(',', '.')) */
          payload.premiums.trimestral_premium = aux
        }
      }
    }
    const planId = payload.plan.id
    const planIndex = state.quotes.map((quote) => quote.plan.id).indexOf(planId)

    Vue.set(state.quotes[planIndex], 'premiums', payload.premiums)
    Vue.set(state.quotes[planIndex], 'status', payload.status)
  },
  SET_QUOTE(state, payload) {
    state.quotes.push(payload)
  }
}

export const getters = {
  companies: (state) => {
    return state.quotes.reduce((accumulator, quote) => {
      const companyExistOnArray = accumulator.find(
        (company) => company.id === quote.company.id
      )

      if (companyExistOnArray) {
        return accumulator
      }

      return accumulator.concat([quote.company])
    }, [])
  },
  coverages: (state) => {
    return state.quotes.reduce((accumulator, quote) => {
      quote.coverages.forEach((coverage) => {
        const coverageName = coverage.name
        if (coverage.principal) {
          if (accumulator.includes(coverageName)) {
            return accumulator
          }
          accumulator.push(coverageName)
        }
      })

      return accumulator
    }, [])
  },
  maximiumPremiums: (state) => {
    const premiums = {
      annual_premium: 0,
      monthly_premium: 0,
      semester_premium: 0,
      trimestral_premium: 0
    }
    state.quotes.forEach((quote) => {
      const quotePremiums = quote.premiums

      Object.keys(premiums).forEach((key) => {
        const actualPremium = convertCurrencyToFloat(premiums[key])

        if (quotePremiums[key] === null || quotePremiums[key] === undefined) {
          return
        }

        const premium = quotePremiums[key]

        if (actualPremium > convertCurrencyToFloat(premium)) {
          return
        }

        premiums[key] = convertCurrencyToFloat(premium)
      })
    })

    return premiums
  }
}

export const actions = {
  async getPlan({ commit }, { id, planId }) {
    const response = await this.$axios.get(
      `/homeinsurance/results/${id}/${planId}`
    )
    let aux
    if (response.data.premiums.annual_premium !== null) {
      aux = response.data.premiums.annual_premium
      aux = Object.values(aux)[0]
      response.data.premiums.annual_premium = aux
    }
    if (response.data.premiums.monthly_premium !== null) {
      aux = response.data.premiums.monthly_premium
      aux = Object.values(aux)[0]
      response.data.premiums.monthly_premium = aux
    }
    if (response.data.premiums.semester_premium !== null) {
      aux = response.data.premiums.semester_premium
      aux = Object.values(aux)[0]
      response.data.premiums.semester_premium = aux
    }
    if (response.data.premiums.trimestral_premium !== null) {
      aux = response.data.premiums.trimestral_premium
      aux = Object.values(aux)[0]
      response.data.premiums.trimestral_premium = aux
    }

    commit('SET_QUOTE', response.data)
  }
}
